import React from "react";
import { useAuth } from "../../../context/AuthProvider";

export default function PersonalFieldCatalog() {
  const { user } = useAuth();
  const items = user?.personal_fields || [];

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <h3 style={{ margin: "0 0 8px 0" }}>Katalog Personal Field</h3>
        <p style={{ margin: 0 }}>
          Application layer KMS sudah memuat {items.length} field dinamis dari backend.
        </p>
      </div>

      <div style={{ display: "grid", gap: 12 }}>
        {items.map((item) => (
          <div
            key={item.id_personal_field}
            style={{
              border: "1px solid #dbe3ea",
              borderRadius: 10,
              background: "#fff",
              padding: 16,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", gap: 12, marginBottom: 8 }}>
              <strong>{item.label}</strong>
              <span>{item.tipe_data}</span>
            </div>
            <div style={{ fontSize: 14, color: "#475569", marginBottom: 8 }}>
              {item.help_text || "Belum ada help text."}
            </div>
            <div style={{ fontSize: 13, marginBottom: 8 }}>
              Berlaku untuk: {(item.roles || []).map((role) => role.nama).join(", ") || "Semua peran"}
            </div>
            {(item.options || []).length > 0 ? (
              <div style={{ fontSize: 13 }}>
                Opsi: {(item.options || []).map((option) => option.label).join(", ")}
              </div>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
}
